import React, { useEffect, useState } from 'react';
import { Checkbox, Form, Space, Tooltip } from 'antd';
import { RadioCheckboxGroupWrapper, RowLabel, StyledDivider } from './styled';
import { AutoInsightRowProps } from '../types';
import { getOptionMap } from '../../utils';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import Highlight from '@src/components/common/Highlight';
import { useSelector } from 'react-redux';
import { isAdminRoleSelector } from '@src/store/common/selectors';

const AutoInsightRow = ({
  itemKey,
  itemLabel,
  form,
  searchText,
  option: initOption,
}: AutoInsightRowProps) => {
  // option value
  const [curOption, setOption] = useState(initOption);
  const isAdminUser = useSelector(isAdminRoleSelector);

  // it is used for clear selection button
  // we don't set a default value after we click the clear selection
  useEffect(() => {
    if (!initOption) {
      setOption(initOption);
    }
  }, [initOption]);

  const onOptionChange = (e) => {
    if (e.target.value !== curOption) {
      setOption(e.target.value);
    } else {
      setOption(undefined);
    }
  };

  useEffect(() => {
    form.setFieldValue(['metricList', itemKey], {
      option: curOption,
    });
  }, [curOption, form, itemKey]);

  const optionMap = getOptionMap();

  return (
    <>
      <Space>
        <RowLabel>
          {searchText ? <Highlight text={itemLabel} highlight={searchText} /> : itemLabel}
        </RowLabel>
        <Form.Item name={['metricList', itemKey, 'option']} style={{ margin: '10px 0' }}>
          <RadioCheckboxGroupWrapper>
            <Checkbox.Group
              className="radio-checkbox-group"
              value={(curOption ? [curOption] : []) as CheckboxValueType[]}
            >
              {optionMap.map(({ value, label, toolTip }) => (
                <Checkbox
                  key={value}
                  value={value}
                  onChange={onOptionChange}
                  style={isAdminUser ? {} : { cursor: 'not-allowed' }}
                >
                  {isAdminUser ? <Tooltip title={toolTip}>{label}</Tooltip> : label}
                </Checkbox>
              ))}
            </Checkbox.Group>
          </RadioCheckboxGroupWrapper>
        </Form.Item>
      </Space>
      <StyledDivider />
    </>
  );
};

export default AutoInsightRow;
